const translations = {
  "en": {
    "Setup with Ed": "Setup with Ed"
  },
  "zh-tw": {
    "Setup with Ed": "由 Ed 協助設定"
  }
};

export default translations;
